import React, { useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import InputControlMask from './InputControlMask';
import InputMask from 'react-input-mask';

const CardInput = ({
    id,
    field = '',
    label,
    type = 'text',
    placeholder = '',
    value = '',
    classNameContainer = '',
    classNameInput = '',
    onChange = () => '',
    mask = '',
    pattern = undefined,
    title = '',
    required = true,
    icon = undefined,
    info = ''
}) => {

    const cssClassContainer = `${classNameContainer}`;
    const cssClassInput = `${classNameInput} input-field`;
    const cssClassTextArea = `${classNameInput} sg-textarea-field`;

    const cardMask = "9999 9999 9999 9999"

    const [card, setCard] = useState({ value: '', maskedValue: '' });
    //const [currentValue, setCurrentValue] = useState('');


    const onInput = (e) => {

        let c = e.nativeEvent.data;

        if(e.nativeEvent.inputType=='insertFromPaste'){
            let value=e.nativeEvent.target.value;
            let m= setFormat(value);
            m=setMask(m)(true);
            setCard({ ...card, value: value, maskedValue: m });
            onChange({[field]:value});
        }
        else if (c == null) {
            setCard({ value: '', maskedValue: '' });
            onChange({[field]:''});
        } else {
           let v=`${card.value}${c}`;
            setCard({ ...card, value: v, maskedValue: `${card.maskedValue}${c}` });
            onChange({[field]:v});
        }
        waiter();
        
        // 
    }




    let timer;

    const setFormat = input => [...input]
        .map((x, i) => (i + 1) % 4 == 0 && i > 0 && x != ' ' ? `${x} ` : x == ' ' ? '' : x)
        .join('');

    const setMask = input => show => [...input]
        .map((x, i, e) => i > 3 && i < 14 && x != ' ' && (i != (e.length - 1) || show) ? '*' : x)
        .join('').trim();

    const waiter = () => {

        clearTimeout(timer);


        timer = setTimeout(() => {
            setCard(prev => {
                let v= setFormat(prev.value);
                v=setMask(v)(true);
                
                return { ...prev, maskedValue: v }
            });
        }, 600);
    };




    return (
        <div className={cssClassContainer}>
            <div className ="lbl-input">
            <span  htmlFor={id}>{label} {icon}
                {info != '' && <FaInfoCircle color="#E1E1E1" title={info} />}
            </span>
            </div>
            <div className = "control-input-with-btn wrapper ">
            <input
                id={id}
                name={field}
                //onChange={onChangeInternal}
                onInput={onInput}
                className={cssClassInput}
                placeholder={placeholder}
                //value={card.maskedValue}
                required={required}
                title={title}
                value={card.maskedValue}
                maxLength="19"
                autoComplete='off'
            />
            </div>
           

        </div>
    );
}



export { CardInput};
